import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LoadingService } from 'src/app/providers/loading.service';
import { GeoLoc } from 'src/app/interfaces/geoloc.model';
import { GoogleMapService } from 'src/app/providers/google-map.service';

@Component({
  selector: 'app-user-location',
  templateUrl: './user-location.component.html',
  styleUrls: ['./user-location.component.scss'],
})
export class UserLocationComponent implements OnInit {
  form: FormGroup;
  address = '';
  geoLoc: GeoLoc;
  validating = true;

  constructor(
    private modalController: ModalController,
    private fb: FormBuilder,
    private loadingSvc: LoadingService,
    private gmapSvc: GoogleMapService
  ) { }

  ngOnInit() {
    this.loadingSvc.hide();
    this.form = this.fb.group({
      zipcode: ['', Validators.required]
    });
  }

  async save() {
    this.loadingSvc.show();

    if (this.validating) {
      await this.validate();
    } else {
      this.modalController.dismiss(this.geoLoc);
    }
  }

  // =======================================
  private async validate() {
    const val = this.form.get('zipcode').value;
    const geoRes = await this.gmapSvc.getCoordinates(val).toPromise();
    this.address = geoRes.results[0].formatted_address;
    const location = geoRes.results[0]?.geometry.location;
    this.geoLoc = {
      latitude: location.lat,
      longitude: location.lng,
      zipcode: val
    };

    this.validating = false;
    this.loadingSvc.hide();
  }

}
